import GridLayoutWeb from './GridLayout.web';
import GridLayoutMobile from './GridLayout.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? GridLayoutMobile : GridLayoutWeb;
